import NumberFormatter from "@single-js/common/util/number-formatter";
import { plural } from "@single-js/common/util/string";
export function formatLicenseUsage({ usedCapacity, maximumCapacity, unitPricing, }) {
    if (unitPricing) {
        if (maximumCapacity === "unlimited") {
            return `${usedCapacity} ${plural("unit", usedCapacity)} allocated of unlimited available`;
        }
        else {
            return `${usedCapacity} ${plural("unit", usedCapacity)} allocated of ${maximumCapacity} available`;
        }
    }
    else {
        if (maximumCapacity === "unlimited") {
            const usedCapacityBytes = NumberFormatter.formatBytes(usedCapacity);
            return `${usedCapacityBytes} allocated of unlimited available`;
        }
        else {
            const usedCapacityBytes = NumberFormatter.formatBytes(usedCapacity);
            const maximumCapacityBytes = NumberFormatter.formatBytes(maximumCapacity);
            return `${usedCapacityBytes} allocated of ${maximumCapacityBytes} available`;
        }
    }
}
export function formatLicenseType(licenseType) {
    switch (licenseType) {
        case "free":
            return "Free";
        case "enterprise":
            return "Enterprise";
        case "developer":
            return "Developer";
        case "standard":
            return "Standard";
        default:
            return "Unknown";
    }
}
